import React, { useEffect, useState } from 'react';

const useKeyEventOutsideElement = <T extends HTMLElement>(
  ref: React.RefObject<T>,
) => {
  const [keyEventOutside, setKeyEventOutside] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyEvent = (event: KeyboardEvent) => {
      if (ref.current) {
        setKeyEventOutside(!ref.current.contains(event.target as HTMLElement));
      }
    };

    document.addEventListener('keypress', handleKeyEvent);

    return () => document.removeEventListener('keypress', handleKeyEvent);
  }, [ref]);

  return keyEventOutside;
};

export default useKeyEventOutsideElement;
